import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-neutral-950 text-white">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 py-20 md:py-32">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-6">
            <div className="flex items-center gap-2 mb-8">
              <span className="inline-block w-3 h-3 bg-[#002FA7]" />
              <span className="font-display font-black tracking-tight text-lg">
                DATAVEX<span className="text-[#FF3300]">/</span>ANALYTICS
              </span>
            </div>
            <h3 className="font-display text-5xl md:text-7xl lg:text-8xl font-black tracking-tighter leading-[0.9]">
              Data to <span className="text-neutral-500">decision.</span>
              <br />
              In production.
            </h3>
            <a
              href="#contact"
              data-testid="footer-cta"
              className="mt-10 inline-flex items-center gap-3 px-6 h-12 bg-white text-black text-sm font-semibold hover:bg-[#FF3300] hover:text-white transition-colors"
            >
              Start an engagement <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
          <div className="col-span-6 lg:col-span-2">
            <div className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-neutral-500 mb-4">
              Practice
            </div>
            <ul className="space-y-3 text-sm">
              <li><a href="#services" className="hover:text-[#FF3300]">B2B Services</a></li>
              <li><a href="#services" className="hover:text-[#FF3300]">B2G Services</a></li>
              <li><a href="#industries" className="hover:text-[#FF3300]">Industries</a></li>
              <li><a href="#cases" className="hover:text-[#FF3300]">Case Studies</a></li>
            </ul>
          </div>
          <div className="col-span-6 lg:col-span-2">
            <div className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-neutral-500 mb-4">
              Company
            </div>
            <ul className="space-y-3 text-sm">
              <li><a href="#method" className="hover:text-[#FF3300]">Methodology</a></li>
              <li><a href="#contact" className="hover:text-[#FF3300]">Contact</a></li>
              <li><a href="#contact" className="hover:text-[#FF3300]">Careers</a></li>
              <li><a href="#contact" className="hover:text-[#FF3300]">Press</a></li>
            </ul>
          </div>
          <div className="col-span-12 lg:col-span-2">
            <div className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-neutral-500 mb-4">
              Compliance
            </div>
            <ul className="space-y-3 text-sm">
              <li>SOC 2 Type II</li>
              <li>ISO 27001</li>
              <li>FedRAMP-aligned</li>
              <li>HIPAA · GDPR</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-neutral-800 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <span className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-neutral-500">
            © {new Date().getFullYear()} Datavex Analytics. All rights reserved.
          </span>
          <div className="flex items-center gap-6 font-mono-tech text-[10px] tracking-[0.2em] uppercase text-neutral-500">
            <a href="#contact" className="hover:text-white">Privacy</a>
            <a href="#contact" className="hover:text-white">Terms</a>
            <a href="#contact" className="hover:text-white">Security</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
